import { Search, TriangleAlert } from 'lucide-react'
import { useMemo, useState } from 'react'
import { usePlatformProductMappings, usePlatformRegistry } from '../platform'

export function CompanyProductMappingsPage() {
  const registry = usePlatformRegistry()
  const resource = usePlatformProductMappings()
  const [search, setSearch] = useState('')
  const [storeId, setStoreId] = useState('')
  const names = useMemo(() => new Map((registry.data?.stores || []).map((store) => [
    store.storeId || store.id || '', store.displayName || store.name || store.storeId || '',
  ])), [registry.data])
  const filtered = useMemo(() => {
    const needle = search.trim().toLowerCase()
    return (resource.data?.mappings || []).filter((mapping) =>
      (!storeId || mapping.storeId === storeId)
      && (!needle || [mapping.platformProductId, mapping.platformVariantId, mapping.companyVariantId]
        .some((value) => String(value || '').toLowerCase().includes(needle))),
    )
  }, [resource.data, search, storeId])

  if (registry.loading || resource.loading) return <div className="loading-state">正在加载商品映射…</div>
  if (registry.error || resource.error || !resource.data) return <div className="error-state"><h1>商品映射不可用</h1><p>{registry.error || resource.error}</p></div>

  return (
    <div className="page-stack company-mapping-page">
      <div className="page-title-row"><div><h1>平台商品映射</h1><p>平台原生商品/规格与公司产品编码分开保存，只展示已确认关系。</p></div></div>
      <section className="product-master-summary">
        <div><span>已确认映射</span><strong>{resource.data.mappings.length.toLocaleString('zh-CN')}</strong></div>
        <div><span>京东规格映射</span><strong>{resource.data.mappings.filter((item) => item.platformId === 'jd').length.toLocaleString('zh-CN')}</strong></div>
        <div><span>拼多多规格映射</span><strong>{resource.data.mappings.filter((item) => item.platformId === 'pinduoduo').length.toLocaleString('zh-CN')}</strong></div>
      </section>
      {resource.data.unmappedScopes.map((scope) => <section className="mapping-warning" key={scope.storeId}><TriangleAlert aria-hidden="true" /><div><strong>{names.get(scope.storeId) || scope.storeId}：规格映射待补</strong><p>{scope.note}</p></div></section>)}
      <section className="product-master-toolbar">
        <label className="search-control"><Search aria-hidden="true" /><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="搜索平台商品ID、规格ID或公司产品编码" /></label>
        <label><span>店铺</span><select value={storeId} onChange={(event) => setStoreId(event.target.value)}><option value="">全部</option>{Array.from(names).map(([id, name]) => <option key={id} value={id}>{name}</option>)}</select></label>
      </section>
      <div className="table-responsive">
        <table><thead><tr><th>平台</th><th>店铺</th><th>平台商品ID</th><th>平台规格ID</th><th>公司产品编码</th><th>生效日</th><th>状态</th></tr></thead>
          <tbody>{filtered.slice(0, 200).map((mapping) => <tr key={mapping.id}><td>{mapping.platformId === 'jd' ? '京东' : mapping.platformId}</td><td>{names.get(mapping.storeId) || mapping.storeId}</td><td>{mapping.platformProductId || '—'}</td><td>{mapping.platformVariantId}</td><td><strong>{mapping.companyVariantId}</strong></td><td>{mapping.effectiveFrom}</td><td>已确认</td></tr>)}</tbody></table>
      </div>
      <p className="table-footnote">当前筛选 {filtered.length.toLocaleString('zh-CN')} 条，页面最多展示前200条；映射关系带生效期，失效后保留历史。</p>
    </div>
  )
}
